<template>
  <v-layout wrap>
    <v-flex
      xs12
    >
      <material-app-card
        class="wbs-list"
        :color="section_color"
        icon="mdi-account-plus"
        title="Additional Requestor"
      >
        <div class="mb-3 px-4 pt-3 pb-5 grey lighten-2">
          <div class="font-weight-bold" style="text-align:left">Filter</div>
            <v-text-field
              outlined
              dense
              hide-details
              background-color="white"
              color="grey"
              class="mb-3"
              prepend-inner-icon="mdi-magnify"
              v-model="requestor.table.filter.keyword"
            ></v-text-field>
          <div class="d-flex align-top justify-space-between">
            <div>
              <div 
                v-for="(rtfx, rtfi) in requestor.table.filter.columns"
                :key="'request-table-filter-'+rtfi"
                style="width:fit-content!important"
              >
                <v-checkbox
                  dense
                  hide-details
                  :color="section_color"
                  class="mt-n1 ml-1"
                  background-color="grey lighten-2"
                  :label="rtfx.text"
                  v-model="rtfx.active"
                ></v-checkbox>
              </div>
            </div>
          </div>
        </div>
        <v-data-table
          class="extra-requestor-table"
          :loading="requestor.table.loading.data"
          :headers="requestor.table.headers"
          :items="requestorTableItemsDisplay"
          :items-per-page="requestor.table.itemsPerPage"
          :page="requestor.table.page"
        >
          <template v-slot:item.cost_center="{ item }">
            <v-text-field
              v-if="item.editing || item.saving"
              :disabled="item.saving"
              outlined
              dense
              hide-details
              color="black"
              v-model="item.edit.cost_center"
            ></v-text-field>
            <v-text-field
              v-else
              disabled
              outlined
              dense
              hide-details
              color="black"
              v-model="item.cost_center"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{item}">
            <template v-if="item.saving">
              <div class="my-4" style="height:20px">Saving...</div>
            </template>
            <template v-else-if="item.deleting">
              <div class="my-4" style="height:20px">Deleting...</div>
            </template>
            <template v-else-if="item.editing">
              <v-btn
                fab
                x-small
                dark
                color="red lighten-1"
                class="ml-1"
                @click="removeEditingTableItem(item)"
              ><v-icon>mdi-trash-can</v-icon></v-btn>
              <v-btn
                fab
                x-small
                dark
                color="green lighten-1"
                class="ml-1"
                @click="saveEditingTableItem(item)"
              ><v-icon>mdi-content-save</v-icon></v-btn>
              <v-btn
                fab
                x-small
                dark
                color="blue lighten-3"
                class="ml-1"
                @click="cancelEditingTableItem(item)"
              ><v-icon>mdi-replay</v-icon></v-btn>
            </template>
            <template v-else>
              <v-btn
                fab
                x-small
                dark
                color="blue darken-1"
                class="ml-1"
                @click="editTableItem(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
          </template>
          <template v-slot:body.append>
            <tr 
              v-if="!requestor.table.loading.data"
              class="extra-requestor-table-spacer-tr-prep"
            ><td></td><td></td><td></td></tr>
            <tr
              v-for="(rtax, rtai) in requestor.table.addedItems"
              :key="'request-table-added-item-'+rtai"
              class="extra-requestor-table-added-item-tr"
            >
              <td>
                <v-text-field
                  class="ml-n3"
                  outlined
                  dense
                  hide-details
                  color="black"
                  backgrounr-color="white"
                  :disabled="rtax.saving"
                  v-model="rtax.email"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  outlined
                  dense
                  hide-details
                  color="black"
                  backgrounr-color="white"
                  :disabled="rtax.saving"
                  v-model="rtax.cost_center"
                ></v-text-field>
              </td>
              <td>
                <div class="d-flex align-center">
                  <v-spacer></v-spacer>
                  <template v-if="rtax.saving">
                    <div class="my-4" style="height:20px">Saving...</div>
                  </template>
                  <template v-else>
                    <v-btn
                      fab
                      x-small
                      dark
                      color="green lighten-1"
                      class="ml-1"
                      @click="saveAddedTableItem(rtax)"
                    ><v-icon>mdi-content-save</v-icon></v-btn>
                    <v-btn
                      fab
                      x-small
                      dark
                      color="red lighten-2"
                      class="ml-1"
                      @click="removeAddedTableItem(rtax)"
                    ><v-icon>mdi-close</v-icon></v-btn>
                  </template>
                </div>
              </td>
            </tr>
            <tr 
              v-if="!requestor.table.loading.data"
              class="extra-requestor-table-add-btn-tr"
            ><td></td><td></td><td>
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-btn
                  fab
                  x-small
                  dark
                  color="blue"
                  class="ml-1"
                  @click="addNewItem"
                ><v-icon>mdi-plus-thick</v-icon></v-btn>
              </div>
            </td></tr>
            <tr 
              v-if="!requestor.table.loading.data"
              class="extra-requestor-table-spacer-tr-appe"
            ><td></td><td></td><td></td></tr>
          </template>
        </v-data-table>
      </material-app-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { section_color } from "@/config";
import { xPost } from '@/functions/http/axios'

export default {
  data () { return {
    me: {
      display: false,
    },
    requestor: {
      table: {
        loading: {
          data: false,
        },
        filter: {
          keyword: null,
          columns: [
            {
              value: 'email',
              text: 'User Email',
              active: true,
            },
            {
              value: 'cost_center',
              text: 'Cost Center',
              active: true,
            },
          ],
        },
        headers: [
          {
            value: 'email',
            text: 'User Email',
            sortable: false,
            align: 'left',
          },
          {
            value: 'cost_center',
            text: 'Cost Center',
            sortable: false,
            align: 'left',
          },
          {
            value: 'actions',
            text: '',
            sortable: false,
            align: 'right',
            width: '150px',
          },
        ],
        items: [],
        addedItems: [],
        addedItemIndex: 0,
        page: 1,
        itemsPerPage: 10,
      },
    },
  }},
  computed: {
    ...mapGetters('user', [
      'loginStatus',
      // 'userEmail',actions
      // 'userInfo',
    ]),
    ...mapGetters('app', [
      'isMobile'
    ]),
    section_color() {
      return section_color['admin']
    },

    // data
    requestorTableItemsDisplay () {
      return this.requestor.table.items.filter(el => 
        !(this.requestor.table.filter.keyword)
        || this.requestor.table.filter.columns.some(x =>
          x.active && (typeof el?.[x.value] === 'string' && el?.[x.value].toLowerCase().search(this.requestor.table.filter.keyword.toLowerCase())>-1)
        )
      )
    },
  },
  methods: {
    ...mapActions('app', ['setMainTitle']),
    
    // functions
    async checkUserAccess () {
      let requestAdminAccess = await this.postRequestAdminAccess()
      if (!requestAdminAccess) {
        this.$router.push('/')
      }
    },
    async getExtraRequestors () {
      this.requestor.table.loading.data = true
      let dataExtraRequestors = await this.postGetExtraRequestors()
      this.requestor.table.items = dataExtraRequestors.map(x => ({
        ...x,
        edit: {
          cost_center: x?.cost_center ?? null,
        },
        editing: false,
        saving: false,
        deleting: false,
      }))
      this.requestor.table.loading.data = false
    },
    editTableItem (item) {
      Object.keys(item.edit).forEach(x =>
        item.edit[x] = item[x]
      )
      item.editing = true
    },
    async saveEditingTableItem (item) {
      item.saving = true
      const { done } = await this.postSaveExtraRequestors(
        item.email,
        item.edit.cost_center
      )
      item.cost_center = item.edit.cost_center
      item.saving = false
      item.editing = false
    },
    async removeEditingTableItem (item) {
      item.deleting = true
      const { done } = await this.postRemoveExtraRequestors(
        item.email
      )
      this.requestor.table.items.splice(
        this.requestor.table.items.findIndex(x =>
          x.email === item.email
        ),
        1
      )
      item.deleting = false
    },
    cancelEditingTableItem (item) {
      item.editing = false
    },
    addNewItem () {
      this.requestor.table.addedItemIndex +=1
      this.requestor.table.addedItems.push({
        uid: this.requestor.table.addedItemIndex,
        email: null,
        cost_center: null,
        saving: false,
      })
    },
    async saveAddedTableItem (item) {
      const uid = item.uid
      const email = item.email
      const cost_center = item.cost_center
      item.saving = true
      const { done } = await this.postSaveExtraRequestors(email, cost_center)
      if (done) {
        this.requestor.table.items.splice(
          this.requestor.table.items.findIndex(x =>
            x.email > email
          ),
          0,
          {
            email: item?.email,
            cost_center: item?.cost_center ?? null,
            edit: {
              cost_center: item?.cost_center ?? null,
            },
            editing: false,
            saving: false,
            deleting: false,
          }
        )
        this.requestor.table.addedItems.splice(
          this.requestor.table.addedItems.findIndex(x =>
            x.uid === uid
          ),
          1
        )
      }
      item.saving = false
    },
    removeAddedTableItem (item) {
      this.requestor.table.addedItems.splice(
        this.requestor.table.addedItems.findIndex(x =>
          x.uid === item.uid
        ),
        1
      )
    },
    init () {
      this.me.display = true
      this.getExtraRequestors()
    },
    
    // post
    /**
     * request access
     */
    async postRequestAdminAccess() {
      try {
        const res = await xPost(
            'admin',
            'access',
            {
              loginStatus: this.loginStatus
            }
          )
          if (res.data.status === 200) {
            return res.data.extra_requestor ?? false
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [request admin access]')
        // console.log(err)
      }
      return false
    },
    async postGetExtraRequestors() {
      try {
        const res = await xPost(
            'admin',
            'get_extra_requestors',
            {
              loginStatus: this.loginStatus
            }
          )
          if (res.data.status === 200) {
            return res.data.data ?? false
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [Get Extra Requestors]')
        // console.log(err)
      }
      return false
    },
    async postSaveExtraRequestors(email, cost_center) {
      try {
        const res = await xPost(
            'admin',
            'save_extra_requestors',
            {
              loginStatus: this.loginStatus,
              email,
              cost_center,
            }
          )
          if (res.data.status === 200) {
            return {
              done: res.data.done ?? false
            }
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [Save Extra Requestors]')
        // console.log(err)
      }
      return false
    },
    async postRemoveExtraRequestors(email) {
      try {
        const res = await xPost(
            'admin',
            'remove_extra_requestors',
            {
              loginStatus: this.loginStatus,
              email,
            }
          )
          if (res.data.status === 200) {
            return {
              done: res.data.done ?? false
            }
          } else {
            try {
              if (res.data.message === 'Authorize Failed') {
                // this.$router.push('/login')
              }
            } catch (e) {}
            throw ''
          }
      } catch (err) {
        console.log('Error [Remove Extra Requestors]')
        // console.log(err)
      }
      return false
    },
  },
  created () {
    // set title
    this.setMainTitle('Admin - Additional Requestor')
    // check access
    this.checkUserAccess()
    this.init()
  },
}
</script>

<style lang="sass">
.extra-requestor-table 
  .extra-requestor-table-spacer-tr-prep td
    height: 2px !important
    background: #ccc
  .extra-requestor-table-spacer-tr-appe td
    height: 1px !important
    background: #bbb
  .extra-requestor-table-added-item-tr td
    background: #fff
  .extra-requestor-table-add-btn-tr td
    background: #fff
</style>